import Vue from 'vue'
import VueRouter from 'vue-router'
// 导入登录组件
import repayment from '../components/repayment.vue'
import rollover from '../components/rollver_page.vue'

Vue.use(VueRouter)

const routes = [
    
  // 根路径重定向到
  {
    path: '/',
    redirect: '/repayment'
  },
  // 支付页面
  {
    path: '/repayment',
    component: repayment
  },
  {
    path: '/rollover',
    component: rollover
  },

]

const router = new VueRouter({
  routes,
  mode: 'hash'
})

export default router

